/**
 * TerraMind typography scale.
 *
 * ONE place to rule all font sizes. Import `TS` in any component
 * instead of hardcoding strings. Changing a value here updates the
 * entire app.
 *
 * Scale (desktop farmer app — readable at arm's length):
 *   xs   → 12px — chart axis ticks, map legend ticks (absolute minimum)
 *   sm   → 13px — true metadata (timestamps, legal, sub-labels)
 *   md   → 14px — secondary labels, chips, badges, table cells
 *   base → 15px — body text, list items, form fields
 *   lg   → 16px — section headers, tab labels, prominent labels
 *   xl   → 18px — card titles, panel headers
 */
export const TS = {
  xs:   '0.75rem',    // 12px
  sm:   '0.8125rem',  // 13px
  md:   '0.875rem',   // 14px
  base: '0.9375rem',  // 15px
  lg:   '1rem',       // 16px
  xl:   '1.125rem',   // 18px
};
